import { Outlet } from "react-router-dom";

const UserContainer = () => {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default UserContainer;
